export default __webpack_public_path__ + "static/media/economia.20523626.png";